import { ObjectModel } from 'objectmodel';
import { validSettingKey } from '../../lib/constants';

const Setting = new ObjectModel({
  key: Object.values(validSettingKey),
  value: [Number, String, Boolean, Object]
});

export { Setting };



/** WEBPACK FOOTER **
 ** ./~/kaistore-post-messenger/src/models/Setting.js
 **/